export const clientStatusToTextLabel = {
  signed: 'Component.Administration.Clients.Status.Signed',
  hot_lead: 'Component.Administration.Clients.Status.HotLead',
  cold_lead: 'Component.Administration.Clients.Status.ColdLead',
  lost: 'Component.Administration.Clients.Status.Lost',
};



// WEBPACK FOOTER //
// ./src/components/Clients/constants.js